import { mapState } from "vuex";
export const appltIndexMixins = {
  computed: {
    ...mapState({
      shopInfo: (state) => state.shopInfo,
      applitInfo: (state) => state.applitInfo,
      appltType: (state) => state.appltType,
      isOwn: (state) => state.isOwn,
      userFuncInfo: (state) => state.userFuncInfo,
    }),
    appltTopBarList() {
      let topbarList = [
        {
          name: "概况",
          isActive: false,
          path: "/applt",
          isDisabled: false,
          icon:require("@/assets/img/menuIcons/icon-applt.png")
        },
        {
          name: "基础信息",
          isActive: false,
          path: "/applt/info",
          isDisabled: false,
          icon:require("@/assets/img/menuIcons/icon-appltinfo.png")
        },
        {
          name: "模板选择",
          isActive: false,
          path: "/applt/template",
          isDisabled: false,
          icon:require("@/assets/img/menuIcons/icon-applttemplate.png")
        },
        {
          name: "聚合码",
          isActive: false,
          path: "/applt/qrCode",
          isDisabled: false,
          icon:require("@/assets/img/menuIcons/icon-appltqrCode.png")
        },
        {
          name: "装修",
          isActive: false,
          path: "/applt/decoration",
          isDisabled: false,
          icon:require("@/assets/img/menuIcons/icon-appltdecoration.png")
        },
        // {
        //   name: "快速创建微信小程序说明",
        //   isActive: false,
        //   path: "/applt/createMiniProgram",
        //   isDisabled: false,
        // },
        {
          name: "自定义图标",
          isActive: false,
          path: "/applt/customerIcon",
          isDisabled: false,
          icon:require("@/assets/img/menuIcons/icon-appltcustomerIcon.png")
        },
      ];
      if (this.shopInfo.edcShopType == 2) {
        topbarList = [
          {
            name: "概况",
            isActive: false,
            path: "/applt",
            isDisabled: false,
            icon:require("@/assets/img/menuIcons/icon-applt.png")
          },
          {
            name: "基础信息",
            isActive: false,
            path: "/applt/info",
            isDisabled: false,
            icon:require("@/assets/img/menuIcons/icon-appltinfo.png")
          },
          {
            name: "模板选择",
            isActive: false,
            path: "/applt/template",
            isDisabled: false,
            icon:require("@/assets/img/menuIcons/icon-applttemplate.png")
          },
          {
            name: "聚合码",
            isActive: false,
            path: "/applt/qrCode",
            isDisabled: false,
            icon:require("@/assets/img/menuIcons/icon-appltqrCode.png")
          },
          {
            name: "装修",
            isActive: false,
            path: "/applt/decoration",
            isDisabled: false,
            icon:require("@/assets/img/menuIcons/icon-appltdecoration.png")
          },
        ];
      }
      if (this.userFuncInfo && this.userFuncInfo.userFuncStatus == 30) {
        topbarList.push({
          name: "平台小程序聚合码",
          isActive: false,
          path: "/applt/userCode",
          isDisabled: false,
          icon:require("@/assets/img/menuIcons/icon-appltqrCode.png")
        });
      }
      // topbarList = topbarList.filter((val) => {
      //   return val.path != "/applt/decoration";
      // });
      topbarList.forEach((val) => {
        if (val.path == this.$route.path) {
          val.isActive = true;
        }
        // console.log(this.applitInfo, !this.applitInfo);
        if (this.applitInfo && this.applitInfo.isAuth == 0 && val.path != "/applt") {
          val.isDisabled = true;
        }
        if (!this.applitInfo && val.path != "/applt") {
          val.isDisabled = true;
        }
        if (val.childrenPath) {
          if (~val.childrenPath.indexOf(this.$route.path)) {
            val.isActive = true;
          }
        }
      });
      return topbarList;
    },
  },
}
